import { Component, OnInit, Input } from '@angular/core';
import { faPlus, faTimes, faPencil, faSync, faUpload } from '@fortawesome/pro-light-svg-icons';
import { AddInvoiceItemComponent } from './../add-invoice-item/add-invoice-item.component';
import { EditInvoiceItemComponent } from './../edit-invoice-item/edit-invoice-item.component';
import { CaseService } from '../../../../shared/services/case.service';
import { InvoiceService } from '../../../../shared/services/invoice.service';
import { CorrespondenceTimelineService } from 'src/app/shared/services/correspondence-timeline.service';
import { InvoiceUploaderComponent } from './../invoice-uploader/invoice-uploader.component';
import { AddInvoiceComponent } from '../add-invoice/add-invoice.component';
import { KlyantService } from '../../../../shared/services/klyant.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { YesNoPopupComponent } from 'src/app/shared/components/yes-no-popup/yes-no-popup.component';
import { OkPopupComponent } from 'src/app/shared/components/ok-popup/ok-popup.component';

@Component({
  selector: 'app-invoice',
  templateUrl: './invoice.component.html',
  styleUrls: ['./invoice.component.scss']
})
export class InvoiceComponent implements OnInit {

  @Input() caseId : number;
  @Input() invoiceId: number;
  @Input() caseTypeId : number;

  faPlus = faPlus;
  faPencil= faPencil;
  faTimes= faTimes;
  faSync= faSync;
  faUpload = faUpload;

  invoice: any;

  caseCompleted: boolean;
  hasError: boolean = false;
  errorMessage: any[] = []; 
  feeTypes: any[] = [];
  columnTitles: any[] = [];
  refreshingData: boolean = false;

  invoiceItems: any[] = [];
  professionalCharges: any[] = [];
  additionalCharges: any[] = [];
  disbursements: any[] = [];
  thirdPartyFees: any[] = [];

  professionalChargesTotal: number = 0;
  additionalChargesTotal: number = 0;
  disbursementsTotal: number = 0;
  thirdPartyFeesTotal: number = 0;

  professionalChargesVatTotal: number = 0;
  additionalChargesVatTotal: number = 0;
  disbursementsVatTotal: number = 0;
  thirdPartyFeesVatTotal: number = 0;

  isGeneratingCompletionStatement: boolean = false;
  readOnly: boolean = false;
  sendingToKlyant: boolean = false;

  public creatingInvoice: boolean = false;

  invoiceChanged: boolean = false;

  constructor(private invoiceService: InvoiceService,
              private klyantService: KlyantService,
              private correspondenceTimelineService: CorrespondenceTimelineService,
              public modalService: ModalService,
              public activeModal: NgbActiveModal) {

  }

  ngOnInit(): void {    

    this.loadInvoiceAndFeeTypes();
   
  }


  loadInvoiceAndFeeTypes(){
    this.invoiceService.getInvoiceById(this.caseId, this.invoiceId).subscribe((response : any) => {
      this.invoice = response.invoice;   
      this.caseCompleted = response.caseCompleted;     

      if(this.invoice.klyantInvoiceId)
      {
        this.readOnly = true;
        this.loadInvoiceItems();
      }
      else
      {
        this.readOnly = false;
        this.generateInvoiceItemsForMissingPreInvoiceFees(); // Also loads invoice items
      }
    });

    // Set the titles based on the API enum description
    this.invoiceService.getFeeTypes().subscribe((response : any) => {      
      this.feeTypes = response;
      this.columnTitles[0] = this.feeTypes.filter(x => x.key == 1)[0].value;
      this.columnTitles[1] = this.feeTypes.filter(x => x.key == 2)[0].value;
      this.columnTitles[2] = this.feeTypes.filter(x => x.key == 3)[0].value;
      this.columnTitles[3] = this.feeTypes.filter(x => x.key == 4)[0].value;
    });
  }

  loadInvoiceAndFeeTypes2(){
    this.invoiceService.getInvoice(this.caseId).subscribe((response : any) => {
      this.invoiceId = response.invoiceId;   
      this.caseCompleted = response.caseCompleted;        
      this.generateInvoiceItemsForMissingPreInvoiceFees(); // Also loads invoice items
    });

    // Set the titles based on the API enum description
    this.invoiceService.getFeeTypes().subscribe((response : any) => {      
      this.feeTypes = response;
      this.columnTitles[0] = this.feeTypes.filter(x => x.key == 1)[0].value;
      this.columnTitles[1] = this.feeTypes.filter(x => x.key == 2)[0].value;
      this.columnTitles[2] = this.feeTypes.filter(x => x.key == 3)[0].value;
      this.columnTitles[3] = this.feeTypes.filter(x => x.key == 4)[0].value;
    });
  }

  disableGenerateInvoice() {
    
    if(this.professionalCharges.length == 0 && this.additionalCharges.length == 0 && this.disbursements.length == 0)
      return true;

    return false;
    
  }

  generateInvoiceItemsForMissingPreInvoiceFees() {
    this.refreshingData = true;
    this.invoiceService.syncInvoiceItemsToPreInvoiceFees(this.caseId, this.invoiceId).subscribe((response : any) => {
      this.loadInvoiceItems();
      this.refreshingData = false;
    });
  }

  loadInvoiceItems() {
    this.invoiceService.getInvoiceItems( this.caseId, this.invoiceId, 1).subscribe((response : any) => {
      this.professionalCharges = response.invoiceItems;

      this.professionalChargesTotal = 0;
      this.professionalChargesVatTotal = 0;
        this.professionalCharges.forEach( (charge:any) => {
        this.professionalChargesTotal += charge.net;
        if(charge.vat)
          this.professionalChargesVatTotal += charge.vat;
      });
    });

    this.invoiceService.getInvoiceItems( this.caseId, this.invoiceId, 2).subscribe((response : any) => {
      this.disbursements = response.invoiceItems;

       this.disbursementsTotal = 0;
       this.disbursementsVatTotal = 0;
        this.disbursements.forEach( (charge:any) => {
        this.disbursementsTotal += charge.net;
        if(charge.vat)
          this.disbursementsVatTotal += charge.vat;
      });
    });

    this.invoiceService.getInvoiceItems( this.caseId, this.invoiceId, 3).subscribe((response : any) => {
      this.additionalCharges = response.invoiceItems;

       this.additionalChargesTotal = 0;
       this.additionalChargesVatTotal = 0;
        this.additionalCharges.forEach( (charge:any) => {
        this.additionalChargesTotal += charge.net;
        if(charge.vat)
          this.additionalChargesVatTotal += charge.vat;
      });
    });

    this.invoiceService.getInvoiceItems( this.caseId, this.invoiceId, 4).subscribe((response : any) => {
      this.thirdPartyFees = response.invoiceItems;

       this.thirdPartyFeesTotal = 0;
       this.thirdPartyFeesVatTotal = 0;
        this.thirdPartyFees.forEach( (charge:any) => {
        this.thirdPartyFeesTotal += charge.net;
        if(charge.vat)
          this.thirdPartyFeesVatTotal += charge.vat;
      });
    });
  }

  addInvoiceItem(feeType: number){

    const modalRef = this.modalService.openWithOptions(AddInvoiceItemComponent, { size: 'md' });
                      
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.invoiceId = this.invoiceId;
    modalRef.componentInstance.feeType = feeType;

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.loadInvoiceItems();
        }
      },
      () => {} // dismissed - do nothing
    );

  }

  editInvoiceItem(item: any){

    const modalRef = this.modalService.openWithOptions(EditInvoiceItemComponent, { size: 'md' });
                      
    modalRef.componentInstance.caseId = this.caseId;
    modalRef.componentInstance.invoiceId = this.invoiceId;
    modalRef.componentInstance.invoiceItem = item;

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.loadInvoiceItems();
        }
      },
      () => {} // dismissed - do nothing
    );
  }

  removeInvoiceItem(itemId: number){

    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                      
    modalRef.componentInstance.messageHeader = 'Are you sure you want to remove this item?';

    modalRef.result.then(
      (result) => {
        if(result)
        {
          this.invoiceService.removeInvoiceItem( this.caseId, this.invoiceId, itemId ).subscribe((response : any) => {
            this.loadInvoiceItems();
          });
        }
      },
      () => {} // dismissed - do nothing
    );
  }

  generateInvoice() {

    var assignedOutlays = true;

    this.disbursements.forEach((item: any) => {
      if(item.klyantOutlayId == null) {
        assignedOutlays = false;        
      }
    });

    if(!assignedOutlays) {

      const modalRef = this.modalService.openWithOptions(OkPopupComponent, { size: 'lg' });
                            
      modalRef.componentInstance.messageHeader = 'Please send all Pre-Invoice Disbursements to Klyant!';
      modalRef.componentInstance.popupText1 = 'One or more disbursements have not been sent to  Klyant.';
    }
    else {

        const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                              
        modalRef.componentInstance.messageHeader = 'Are you sure you want to generate the invoice';

        modalRef.result.then(
          (result) => {
             if(result)
              {
                this.creatingInvoice = true;
                this.hasError = false;
                this.invoiceService.generateInvoiceNumberAndPrintInvoice(this.caseId, this.invoiceId).subscribe((response : any) => {
                  this.creatingInvoice = false;
                  this.loadInvoiceAndFeeTypes();
                  
                  this.correspondenceTimelineService.refreshCaseTimeline.next();
                  this.invoiceChanged = true;
                }, (error: any) => {            
                  this.creatingInvoice = false;
                  this.hasError = true;
                  this.errorMessage = error.error;
                });
              }
          },
          () => {} // dismissed - do nothing
        );
    }
  }



  generateCompletionStatement(){

    this.isGeneratingCompletionStatement = true;

    this.invoiceService.generateCompletionStatement( this.caseId, this.invoiceId).subscribe((response : any) => {
      this.activeModal.close();
      this.correspondenceTimelineService.refreshCaseTimeline.next();
    });

  }

  refreshAutoLines() {



  const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                              
        modalRef.componentInstance.messageHeader = 'Are you sure you want to regenerate the default invoice items';

        modalRef.result.then(
          (result) => {
            if(result)
            {
              this.refreshingData = true;
              this.invoiceService.refreshAutoLines( this.caseId, this.invoiceId).subscribe((response : any) => {
                this.loadInvoiceItems();
                this.refreshingData = false;
              });
            }
          },
      () => {} // dismissed - do nothing
    );
      
  }

  openInvoiceUploader(){

    const modalRef = this.modalService.openWithOptions(InvoiceUploaderComponent, { size: 'md'});
                    
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
        if (result == true){
          this.generateInvoiceItemsForMissingPreInvoiceFees();
        }
    });
   
  }

  openAddInvoice(){

    const modalRef = this.modalService.openWithOptions(AddInvoiceComponent, { size: 'md'});
                
    modalRef.componentInstance.caseId = this.caseId;

    modalRef.result.then(
      (result) => {
        if(result > 0)
    {
      this.invoiceId = result;
      this.loadInvoiceAndFeeTypes();
      this.invoiceChanged = true;
    }
    },
      () => {} // dismissed - do nothing
    );

  }

  sendToKlyant()
  {
    this.errorMessage[0] = "";
    const modalRef = this.modalService.openWithOptions(YesNoPopupComponent, { size: 'lg' });
                      
      modalRef.componentInstance.messageHeader = 'Are you sure you want to send the invoice to Klyant?';
      modalRef.componentInstance.popupText1 = 'THE INVOICE WILL NOT BE EDITABLE IN THE PORTAL ONCE SENT TO KLYANT'

      modalRef.result.then(
        (result) => {
          if(result)
          {
            this.sendingToKlyant = true;
            this.klyantService.sendInvoiceToKlyant(this.caseId, this.invoiceId).subscribe((response) => {
              this.loadInvoiceAndFeeTypes();
                this.sendingToKlyant = false;
                this.invoiceChanged = true;
            }, (error: any) => {            
              this.hasError = true;
              this.errorMessage[0] = error.error;
              this.sendingToKlyant = false;
            });

          }
      },
      () => {} // dismissed - do nothing
    );
  }

  close(){
    this.activeModal.close(this.invoiceChanged);
  }

}
